import { TrackingPageType } from '@shopee-user/business-customization-types';

export const PageType: TrackingPageType = {
  LoginPage: 'foody_driver_login',
  OTPDialogPopup: 'foody_driver_alert_popup',
  OTPEnterVerificationPage: 'foody_driver_enter_verification_code',
  OTPSelectVerificationMethodPage: 'foody_driver_select_verification_method',
  ResetPasswordPage: '',
  SetNewPasswordPage: '',
  VerifyCurrentPasswordPage: '',
  MyAccountPage: 'foody_driver_my_account',
  MyStaffAccountListPage: '',
  StaffAccountDetailsPage: '',
  MerchantAccountSettingPage: '',
  EnterNewPhonePage: 'foody_driver_new_phone_number',
  EnterNewEmailPage: '',
  ChangePhonePage: 'foody_driver_change_phone_number',
  ChangeEmailPage: 'foody_driver_change_email',
  AccountUpdateMethodSelectionPage: '',
  AccountUpdateOverviewPage: '',
  AccountUpdateSuccessPage: '',
  AccountBindAccountBindingPage: '',
  AccountBindReclaimFailurePage: '',
  AccountBindCreateAccountPage: '',
  AccountBindSetPasswordPage: '',
  SignupPage: 'foody_driver_signup',
  SignupPhoneAlreadyRegisteredPage:
    'foody_driver_signup_number_already_registered',
  SignupEmailAlreadyRegisteredPage:
    'foody_driver_signup_email_already_registered',
  SignupSetPasswordPage: 'foody_driver_set_tob_password',
  SignupSuccessPage: 'foody_driver_tob_account_created',
  BiometricPromptPage: 'foody_driver_biometric_prompt',
  ReloginBiometricsPage: 'foody_driver_relogin',
  ReloginQuickLoginPage: 'foody_driver_quick_login_relogin',
  ReloginPasswordPage: 'foody_driver_password_relogin',
  // TODO: add for relogin OTP
  WhatsappAuthLink: 'tob_verify_wa_auth_link',
  OneCredentialDelinkInitPage: '',
  OneCredentialDelinkSetupTobAccountPage: '',
  OneCredentialDelinkSetupPasswordPage: '',
  OneCredentialDelinkSuccessPage: '',
  OneCredentialDelinkErrorPage: '',
  ThirdPartyAccountLinkagePage: '',
  QuickLoginPromptPage: 'foody_driver_quick_login_prompt',
};
